export default __webpack_public_path__ + "389feff7d64079b3a6fd8f76970cd708.png";